import { render, staticRenderFns } from "./SettingIndex.vue?vue&type=template&id=3d5596e0&scoped=true"
import script from "./SettingIndex.vue?vue&type=script&lang=js"
export * from "./SettingIndex.vue?vue&type=script&lang=js"
import style0 from "./SettingIndex.vue?vue&type=style&index=0&id=3d5596e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5596e0",
  null
  
)

export default component.exports